//=require _jquery.resize.min.js

$.fancybox.defaults.loop = true;

$(document).ready(function() {
	handle_svg_resize();
});
$(window).resize(debounce(handle_svg_resize, 100));
$('.cmspage_gabarit4_3, .cmspage_gabarit4_3_4, .cmspage_gabarit5, .cmspage_gabarit7, .cmspage_gabarit10, .cmspage_gabarit11').resize(debounce(handle_svg_resize, 100));

function handle_svg_resize() {
	if (!$('body').hasClass('mode_mobile')) {
		var window_width = $(window).width();

		$('.cmspage_gabarit4_3, .cmspage_gabarit4_3_4, .cmspage_gabarit7, .cmspage_gabarit10, .cmspage_gabarit11').each(function() {
			var gabarit = $(this);
			var gabarit_height = gabarit.innerHeight();
			var svg = gabarit.find('.svg_blob').first();
			var svg_viewbox_array = svg[0].getAttribute('viewBox').split(' ');
			var svg_ratio = svg_viewbox_array[2] / svg_viewbox_array[3];
			var svg_width = gabarit_height * svg_ratio;
			var decalage = (svg_width - window_width) / 2;
			if (decalage > 0) {
				decalage *= -1;
			}
			svg.css({'width': svg_width + 'px', 'left': decalage + 'px', 'right': decalage + 'px'});
		});
		$('.cmspage_gabarit5').each(function() {
			var gabarit = $(this);
			var gabarit_height = gabarit.innerHeight();
			var svg = gabarit.find('.svg_blob').first();
			var svg_viewbox_array = svg[0].getAttribute('viewBox').split(' ');
			var svg_ratio = svg_viewbox_array[2] / svg_viewbox_array[3];
			var svg_width = gabarit_height * svg_ratio;
			svg.css({'width': svg_width + 'px', 'left': '-' + (svg_width + 315 - gabarit.width()) + 'px'});
		});
	}
}
